import { Component, Input, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser  } from '@angular/common';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-countdown-timer',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './countdown-timer.component.html',
    styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {

    @Input() isCard: boolean = false;
    @Input() isMobile:boolean = false;
    targetDate: string = '2025-08-01T04:00:00Z';

    public days!: number;
    public hours!: number;
    public minutes!: number;
    public seconds!: number;
    public isTimeUp: boolean = false;
    private countdownSubscription!: Subscription;
    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            if (!this.targetDate) {
                console.error("Target date is not set for countdown timer.");
                return;
            }

            const targetTime = new Date(this.targetDate).getTime();

            this.countdownSubscription = timer(0, 1000).pipe(
                map(() => this.calculateTimeDifference(targetTime))
            ).subscribe();
        }
    }

    calculateTimeDifference(targetTime: number): void {
        const now = new Date().getTime();
        const difference = targetTime - now;

        if (difference <= 0) {
            this.isTimeUp = true;
            this.days = 0;
            this.hours = 0;
            this.minutes = 0;
            this.seconds = 0;
            if (this.countdownSubscription) {
                this.countdownSubscription.unsubscribe();
            }
        } else {
            this.days = Math.floor(difference / (1000 * 60 * 60 * 24));
            this.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            this.seconds = Math.floor((difference % (1000 * 60)) / 1000);
        }
    }

    ngOnDestroy(): void {
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
        }
    }
}
